import { FooterYear } from './FooterYear'
import { StoryhealthLogo } from './StoryhealthLogo'

/* Minimal Story Health footer — mirrors FlowFooter's structure:
   logo (left) · legal (right, at 40% opacity). */

export function StoryhealthFooter() {
  return (
    <footer className="sh-footer">
      <div className="sh-footer__inner">
        <a href="https://www.storyhealth.com" className="sh-footer__logo" aria-label="Story Health by Innovaccer">
          <StoryhealthLogo height={32} />
        </a>

        <div className="sh-footer__legal">
          <span>Innovaccer &copy; <FooterYear fallback={new Date().getFullYear()} /></span>
          <a href="https://innovaccer.com/terms-of-use">Terms</a>
          <a href="https://innovaccer.com/privacy">Privacy</a>
        </div>
      </div>
    </footer>
  )
}

export default StoryhealthFooter
